import React, { useState } from 'react';
import { keysRu } from './keys/keys-ru';
import { keysKz } from './keys/keys-kz';
import { keysEn } from './keys/keys-en';
import { keysNumbers } from './keys/keys-numbers';
import classNames from 'classnames';
import { defaultLanguage, languages } from '../../../../translations';

export default function Keyboard({ setText, availableWords, className, onChange, type }) {
  const [isRus, setIsRus] = useState(true);

  const pressKey = (e, key) => {
    const keyboardLogic = {
      bksp: () => setText((value) => value.slice(0, -1)),
      spaceKey: () => setText((value) => value + ' '),
      default: () => setText((value) => value + key),
    };

    (keyboardLogic[key] ?? keyboardLogic.default)();

    onChange?.();
  };

  const typeKeys = (type, isRus, pressKey) => {
    if (type === 'numbers') return keyboardLines(keysNumbers.list, pressKey);

    // Определяем язык по доступным словам
    // Казахские специфичные буквы: ә, ө, ұ, ү, қ, ғ, ң, һ, і
    const hasKazakh = availableWords?.some((word) => /[әөұүқғңһі]/i.test(word));
    const hasRussian = availableWords?.some((word) => /[а-яё]/i.test(word));
    const hasEnglish = availableWords?.some((word) => /[a-z]/i.test(word));
    // Арабские буквы: базовый диапазон Unicode
    const hasArabic = availableWords?.some((word) => /[\u0600-\u06FF]/.test(word));

    let lines;
    if (hasKazakh) {
      lines = keysKz.list;
    } else if (hasRussian || defaultLanguage === languages.ru) {
      lines = keysRu.list;
    } else if (hasArabic) {
      // Нет арабской раскладки — используем английскую
      lines = keysEn.list;
    } else {
      lines = keysEn.list;
    }

    return keyboardLines(lines, pressKey);
  };

  return (
    <div className={classNames('keyboard', className, { [`keyboard_${type}`]: !!type })}>
      {typeKeys(type, isRus, pressKey)}
    </div>
  );

  function keyboardLines(items, pressKey) {
    return items.map(({ line, type }, index) => {
      return (
        <div key={'keyboard-line-' + index} className={'keyboard__line keyboard__line_' + type}>
          {keyboardButtons(line, pressKey)}
        </div>
      );
    });
  }

  function keyboardButtons(items, pressKey) {
    return items.map(({ letter, className, type, decor }, index) => {
      const keyButton = !type ? letter : type;
      // Проверяем, есть ли буква в доступных словах (без учета регистра)
      const isDisabled = !type && !availableWords?.some((word) => word.toLowerCase().includes(letter.toLowerCase()));

      return (
        <button
          disabled={isDisabled}
          key={'keyboard-button-' + index}
          className={'keyboard__button ' + className}
          onClick={(e) => pressKey(e, keyButton)}
        >
          <div className={'keyboard__button-block'}>
            {decor ? <div className={'keyboard__button-decor'}>{decor}</div> : null}
            <div className={'keyboard__button-letter'}>{letter}</div>
          </div>
        </button>
      );
    });
  }
}
